import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import useOutside from "../../hooks/outsideClick";
import { classHelper } from "../../utils/stringUtils";
import * as Variable from "../../utils/variables";
import { CaretDown, BigGridIcon, ListIcon, SmallGridIcon } from "../svg/Icons";
import { useDrag } from "react-use-gesture";
import "./ListingComponent.scss";
import SwitcherAbroadDomestic from "./SwitcherAbroadDomestic";

const ListingComponent = ({
	ENV_NAME,
	className,
	showingLabel,
	showingLabelClassName,
	filters,
	filtersClassName,
	contents,
	contentsClassName,
	hasMore,
	showMoreOnClick,
	hasView = true,
	view,
	isCollege,
	setView,
	handleClickSwitcher,
	activeSwitcher,
	...props
}) => {
	const [showFilters, setShowFilters] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const filterRef = useRef();

	const onHide = () => {
		if (showFilters) setShowFilters(false);
	};

	// Set the drag hook and define component movement based on gesture data
	const bind = useDrag(({ down, movement: [mx, my] }) => {
		if (expanded && down && my > 50) setExpanded(false);
		else if (!expanded && !down && my < -50) setExpanded(true);
		else if (down && ((expanded && my > 200) || (!expanded && my > 150))) setShowFilters(false);
	});

	useEffect(() => {
		if (!showFilters && expanded) {
			setExpanded(false);
		}
	}, [showFilters, expanded]);

	useOutside(filterRef, onHide);

	return (
        <div
            className={classHelper('container listing-component', className)}
            {...props}
        >
            <button
                className="btn lc-btn-filter show-mobile"
                onClick={() => {
                    setShowFilters((p) => !p)
                }}
            >
                <i className="fa fa-filter me-sm" aria-hidden="true" />
                {Variable.FILTERS[ENV_NAME]}
            </button>
            {showFilters && <div className="header-overlay show" />}
            <div
                className={classHelper(
                    'lc-filters',
                    showFilters ? 'show' : '',
                    expanded ? 'expanded' : '',
                    filtersClassName
                )}
                ref={filterRef}
            >
                <div
                    className="flex-all-center show-mobile drag-top"
                    {...bind()}
                    style={{ touchAction: 'none' }}
                >
                    <div className="drag-pill" />
                </div>
                {filters}
            </div>
            <div className="w-100">
                <div className="d-flex align-items-center">
                    <div>
                        <SwitcherAbroadDomestic
                            activeTab={activeSwitcher}
                            onClick={handleClickSwitcher}
                            ENV_NAME={ENV_NAME}
                            isCollege={isCollege}
                        />
                    </div>
                    {hasView && (
                        <div className="lc-view">
                            <button
                                className="view-type btn"
                                onClick={() => setView('big')}
                            >
                                <BigGridIcon
                                    stroke={
                                        view === 'big' ? '#193560' : '#BEC4CF'
                                    }
                                    fill={
                                        view === 'big'
                                            ? '#193560'
                                            : 'transparent'
                                    }
                                />
                            </button>
                            <button
                                className="view-type btn"
                                onClick={() => setView('small')}
                            >
                                <SmallGridIcon
                                    stroke={
                                        view === 'small' ? '#193560' : '#BEC4CF'
                                    }
                                    fill={
                                        view === 'small'
                                            ? '#193560'
                                            : 'transparent'
                                    }
                                />
                            </button>
                            <button
                                className="view-type btn"
                                onClick={() => setView('list')}
                            >
                                <ListIcon
                                    stroke={
                                        view === 'list' ? '#193560' : '#BEC4CF'
                                    }
                                    fill={
                                        view === 'list'
                                            ? '#193560'
                                            : 'transparent'
                                    }
                                />
                            </button>
                        </div>
                    )}
                </div>
                <div className={classHelper('lc-label', showingLabelClassName)}>
                    {`${Variable.SHOWING[ENV_NAME]} `}
                    <strong>{showingLabel}</strong>
                </div>
                <div
                    className={classHelper(
                        'lc-contents',
                        view !== 'list' ? `grid-${view}-view` : 'list-view',
                        contentsClassName
                    )}
                >
                    {contents}
                </div>
                {hasMore && (
                    <button
                        className="btn btn-show-more"
                        onClick={showMoreOnClick}
                    >
                        <CaretDown stroke="#193560" className="me-sm" />
                        {Variable.VIEW_MORE[ENV_NAME]}
                    </button>
                )}
            </div>
        </div>
    )
};

const mapStateToProps = (state) => {
	return { ENV_NAME: state.auth.selectedEnvironment || "bhs" };
};

const mapStateToDispatch = (dispatch) => {
	return {};
};

export default connect(mapStateToProps, mapStateToDispatch)(ListingComponent);
